import { Command } from './command.model';
import { EditorObject } from '../editor-object.model';
import { BaseComponent } from '../components/BaseComponent';
import { EditorCanvasComponent } from 'src/app/editor-canvas/editor-canvas.component';

export class EditCommand implements Command {
    editorObjCopy: EditorObject;
    edObj: EditorObject;
    components: Array<BaseComponent>
    constructor(eo: EditorObject, components: Array<BaseComponent>) {
        this.edObj = eo;
        this.editorObjCopy = eo.copy();
        this.components = components;
    }

    execute(editorCanvas: EditorCanvasComponent): boolean {
        editorCanvas.updateEditorObject(this.edObj, this.components);
        return false;
    }
}